import { useEffect, useState } from 'react'
import { AddressInfo, ApplicationQuestionnaire, customerData } from '../../../utilities/CustomerData'
import { apiURL } from '../../../utilities/URLs'

export function AdvancePaymentQuestionnaire({ handleCompleteQuestionnaire }) {
  const [applicationQuestionnaire, setApplicationQuestionnaire] = useState(new ApplicationQuestionnaire())
  const [hasEIN, setHasEIN] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const handleCheckForEIN = async () => {
      const einResponse = await fetch(`${apiURL}/api/checkForEIN?customerId=${encodeURIComponent(customerData.customerLeadData.leadContact.contactId)}`, {
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const einData = await einResponse.json()
      setLoading(false)
      if(einData.response.error)
        console.error(einData.response.error)
      else
        setHasEIN(einData.response.hasEIN)
    }

    handleCheckForEIN()
  }, [])

  return (
    <div className='w-full flex flex-col items-center'>
      <p className='text-2xl font-bold mb-4'>Application Questionnaire</p>
      {!loading ? (
        <div className='lg:w-full w-11/12 flex flex-col items-center'>
          <p>Please answer a few questions about your work/business.</p>
          <div className='lg:w-1/2 h-full flex flex-row items-stretch justify-center gap-88 mt-10 flex-1'>
            <div className='w-full'>
              <div className='flex flex-col mb-10'>
                <p className='font-bold'>Business Type</p>
                <div className='flex flex-row flex-wrap items-center gap-4'>
                  <div onClick={() => setApplicationQuestionnaire((prevApplication) => ({ ...prevApplication, entityType: 'Limited Partnership' }))} className='cursor-pointer flex flex-row items-center gap-2'>
                    <input 
                      type='checkbox'
                      checked={applicationQuestionnaire.entityType === 'Limited Partnership'}
                      onChange={() => setApplicationQuestionnaire((prevApplication) => ({
                        ...prevApplication,
                        entityType: 'Limited Partnership'
                      }))}
                    />
                    <p>Limited Partnership</p>
                  </div>
                  <div onClick={() => setApplicationQuestionnaire((prevApplication) => ({ ...prevApplication, entityType: 'Limited Liability Co.' }))} className='cursor-pointer flex flex-row items-center gap-2'>
                    <input 
                      type='checkbox'
                      checked={applicationQuestionnaire.entityType === 'Limited Liability Co.'}
                      onChange={() => setApplicationQuestionnaire((prevApplication) => ({
                        ...prevApplication,
                        entityType: 'Limited Liability Co.'
                      }))}
                    />
                    <p>Limited Liability Co.</p>
                  </div>
                  <div onClick={() => setApplicationQuestionnaire((prevApplication) => ({ ...prevApplication, entityType: 'Sole Proprietorship' }))} className='cursor-pointer flex flex-row items-center gap-2'>
                    <input 
                      type='checkbox'
                      checked={applicationQuestionnaire.entityType === 'Sole Proprietorship'}
                      onChange={() => setApplicationQuestionnaire((prevApplication) => ({
                        ...prevApplication,
                        entityType: 'Sole Proprietorship'
                      }))}
                    />
                    <p>Sole Proprietorship</p>
                  </div>
                </div>
              </div>
              <div className='relative mb-4'>
                <p className='absolute text-sm bg-white left-3 top-[-5px]'>Profession</p>
                <input
                  type='text'
                  name='natureOfBusiness'
                  placeholder='Profession'
                  value={applicationQuestionnaire.natureOfBusiness}
                  onChange={(e) => setApplicationQuestionnaire((prevApplication) => ({
                    ...prevApplication,
                    natureOfBusiness: e.target.value
                  }))}
                  className='mt-1 p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:ring-indigo-300'
                />
              </div>
              {hasEIN && (
                <div className='relative mb-4'>
                  <p className='absolute text-sm bg-white left-3 top-[-5px]'>EIN</p>
                  <input
                    type='text'
                    name='ein'
                    placeholder='XX-XXXXXXX'
                    value={applicationQuestionnaire.ein}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, '')
                      if (value.length > 2) {
                        value = `${value.slice(0, 2)}-${value.slice(2, 9)}`
                      }
                      setApplicationQuestionnaire((prevApplication) => ({
                        ...prevApplication,
                        ein: value
                      }))
                    }}
                    maxLength={10}
                    className='mt-1 p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:ring-indigo-300'
                  />
                </div>
              )}
              <div className='flex w-full justify-center'>
                <button
                  disabled={!applicationQuestionnaire.entityType || !applicationQuestionnaire.natureOfBusiness}
                  onClick={() => handleCompleteQuestionnaire(applicationQuestionnaire)}
                  className={`px-8 py-2 mt-4 text-white rounded max-sm:mb-4 ${applicationQuestionnaire.entityType && applicationQuestionnaire.natureOfBusiness ? 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200' : 'bg-gray-400 cursor-not-allowed'}`}>
                  Next
                </button>
              </div>
              <p className='text-sm text-gray-500 italic text-center mt-12 mb-10'>Rest Assured, all the data you provide will be encrypted and stored securely. This information is only used to process your file.</p>
            </div>
          </div>
        </div>
      ) : (
        <div className='flex flex-row items-center justify-center gap-2'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
          <p>Loading...</p>
        </div>
      )}
    </div>
  )
}